import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetYourPropertyWithConfidence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="let-your-property-with-confidence" className="relative h-screen w-full overflow-hidden bg-black">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572105/img/modern_uk_townhouse_hero.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div ref={ref} className={`flex max-w-4xl flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="mb-6 font-serif text-5xl font-medium leading-tight text-white md:text-6xl lg:text-[72px]">
            Let Your Property with Confidence
          </h1>
          
          <p className="mb-10 max-w-2xl font-sans text-lg text-gray-200 md:text-xl">
            Maximize your rental income with LiveAmazing. We provide expert property management 
            and tenant sourcing services tailored for UK landlords.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row sm:gap-6">
            <Button asChild size="lg" className="h-14 min-w-[200px] rounded-sm bg-white px-8 text-base font-semibold uppercase tracking-wide text-black hover:bg-gray-200 hover:text-black border-none">
              <Link to="/LandlordsPage">Book a Valuation</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-sm border-2 border-white bg-transparent px-8 text-base font-semibold uppercase tracking-wide text-white hover:bg-white/20 hover:text-white">
              <Link to="/PropertiesPage">Search Properties</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <Link to="#featured-rental-properties" aria-label="Scroll down">
          <ChevronDown className="h-10 w-10 text-white/80 hover:text-white" />
        </Link>
      </div>
    </section>;
}